import http from "./http";
import config from "../common/config";

var baseUrl="/appuser-web";

//根据uid获取token
const getSysUserByUid = (uid) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-user/login/getSysUserByUid', { uid: uid }).then(result => {
            resolve(result)
        }).catch(error => {
            reject(error);
        })
    });
}
//用户名密码登录
const getUserInfoService = (loginInfo) => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+'/auth/login',  loginInfo ,false,false).then(result => {
            resolve(result)
        }).catch(error => {
            reject(error);
        })
    });
}
//短信验证码登录
const loginByPropertyMsgCodeRSAService = (loginInfo) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-user/login/loginByPropertyMsgCodeRSA', { loginInfo: loginInfo }).then(result => {
            resolve(result)
        }).catch(error => {
            reject(error);
        })

    });
}
//获取用户权限信息
const getUserAuthorityService = (userCode) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-user/login/getUserAuthority', { userCode }).then(result => {
            result.resultCode == 0 ? resolve(result) : reject(result.msg);
        }).catch(error => {
            reject(error);
        })

    });
}

//获取店铺按钮
const getCheckStatusService = (shopCode) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-commerce-shop/shopManage/getCheckStatus', {
            shopCode
        }, true).then(result => {
            result.resultCode == 0 ? resolve(result.data) : reject(result.msg);
        }).catch(error => {
            reject(error);
        })

    });
}

//发送短信验证码
const getMsgCodeService = (accntInfo) => {
    return new Promise((resolve, reject) => {
        http.post('/xwj-sys-user/login/getMsgCode', { accntInfo: accntInfo }, true).then(result => {
            result.success ? resolve(result.success) : reject(result.msg);
        }).catch(error => {
            reject(error);
        })

    });
}

//修改密码接口/login/modifyPassword
const modifyPasswordService = (modifyInfo) => {
    return new Promise((resolve, reject) => {
        http.post('/xwj-sys-user/login/modifyShopPasswordRSA', { modifyInfo }, true).then(result => {
            result.resultCode == 0 ? resolve(result.msg) : reject(result.msg);
        }).catch(error => {
            reject(error);
        })

    });
}

//判断用户是否存在/login/getUser
const getUserService = (userName) => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-user/login/getUser', { userName }, true).then(result => {
            result.resultCode == 0 ? resolve(result.msg) : reject(result.msg);
        }).catch(error => {
            reject(error);
        })

    });
}

//获取登录加密公钥
const getRsaPublicKey = () => {
    return new Promise((resolve, reject) => {
        http.get('/xwj-sys-user/login/getPublicKey').then(noteData => {
            resolve(noteData);
        }).catch(error => {
            reject(error);
        })
    });
}
//用户退出登录
const loginOutOfPropertyService = () => {
    return new Promise((resolve, reject) => {
        http.post(baseUrl+'/auth/logout',{},false,false,false).then(result => {
            resolve(result)
        }).catch(error => {
            reject(error);
        })
    });
}

const getverificationUrl = () => {    //获取验证码接口
    return config.baseUrl + '/xwj-sys-user/login/getVerificationCode';
}

//修改密码
const modifySysUserPasswordService = (modifyInfo) => {
    return new Promise((resolve, reject) => {
        http.put(baseUrl+'/auth/update/password',  modifyInfo, false).then(result => {
            resolve(result)
        }).catch(error => {
            reject(error);
        })
    });
}

//重置密码
const resetSysUserPasswordService = (modifyInfo) => {
    return new Promise((resolve, reject) => {
        http.put(baseUrl+'/auth/refresh/password',  modifyInfo, false).then(result => {
            resolve(result)
        }).catch(error => {
            reject(error);
        })
    });
}


export {
    getSysUserByUid,
    loginByPropertyMsgCodeRSAService,
    loginOutOfPropertyService,
    getUserAuthorityService,
    getCheckStatusService,
    getUserInfoService,
    getMsgCodeService,
    modifyPasswordService,
    getUserService,
    getRsaPublicKey,
    modifySysUserPasswordService,  //更新密码
    resetSysUserPasswordService,    //管理员重置密码
    getverificationUrl
}
